import { createSlice } from "@reduxjs/toolkit";

const subState = () => ({
  items: [],
  isLoading: false,
  hasNextPage: false,
  currentPage: 1,
  currentFilters: {},
});

const initialState = {
  fijo: subState(),
  finDeSemana: subState(),
  top: subState(),
};

const applySuccess = (state, key, payload) => {
  state[key].items = payload.items;
  state[key].isLoading = false;
  state[key].hasNextPage = payload.pagination?.hasNextPage || false;
  state[key].currentPage = payload.pagination?.currentPage || 1;
  if (payload.filters) state[key].currentFilters = payload.filters;
};

const applyAppend = (state, key, payload) => {
  state[key].items = [...state[key].items, ...payload.items];
  state[key].isLoading = false;
  state[key].hasNextPage = payload.pagination?.hasNextPage || false;
  state[key].currentPage = payload.pagination?.currentPage || state[key].currentPage;
};

const experienciasSlice = createSlice({
  name: "experiencias",
  initialState,
  reducers: {
    // Fijo
    experienciasFijoLoading: (state) => { state.fijo.isLoading = true; },
    experienciasFijoSuccess: (state, action) => applySuccess(state, 'fijo', action.payload),
    experienciasFijoAppend: (state, action) => applyAppend(state, 'fijo', action.payload),
    experienciasFijoFailure: (state) => { state.fijo.isLoading = false; },

    // Fin de semana
    experienciasFinDeSemanaLoading: (state) => { state.finDeSemana.isLoading = true; },
    experienciasFinDeSemanaSuccess: (state, action) => applySuccess(state, 'finDeSemana', action.payload),
    experienciasFinDeSemanaAppend: (state, action) => applyAppend(state, 'finDeSemana', action.payload),
    experienciasFinDeSemanaFailure: (state) => { state.finDeSemana.isLoading = false; },

    // Top
    experienciasTopLoading: (state) => { state.top.isLoading = true; },
    experienciasTopSuccess: (state, action) => applySuccess(state, 'top', action.payload),
    experienciasTopAppend: (state, action) => applyAppend(state, 'top', action.payload),
    experienciasTopFailure: (state) => { state.top.isLoading = false; },
  },
});

export const {
  experienciasFijoLoading, experienciasFijoSuccess, experienciasFijoAppend, experienciasFijoFailure,
  experienciasFinDeSemanaLoading, experienciasFinDeSemanaSuccess, experienciasFinDeSemanaAppend, experienciasFinDeSemanaFailure,
  experienciasTopLoading, experienciasTopSuccess, experienciasTopAppend, experienciasTopFailure,
} = experienciasSlice.actions;

export default experienciasSlice.reducer;
